export type MatterFileInfo = {
  id: string
  fileName: string
  fileExtension: string
  sizeBytes?: number
  summary?: string
}

export type GetFileFailure = {
  fileId: string;
  failureReason: string;
}
export const isGetFileFailure = (d: any): d is GetFileFailure => d.failureReason
